import { configManager } from 'utils/configuration';

export type RaffleConfigs = {
  banners: { altText: string; imageUrl: string; toPath?: string }[];
  runningOutPercentage: number;
  maxSingleBuyableTicketQuantity: number;
  maxCartItemQuantity: number;
  showShareButton: boolean;
  landingModalShowingCount: number;
};

function getConfigs(): RaffleConfigs {
  const getConfig = configManager.getInstance().get;

  const raffleConfig = getConfig('RAFFLE') as RaffleConfigs;
  const runningOutPercentage = +raffleConfig.runningOutPercentage;
  const maxSingleBuyableTicketQuantity = +raffleConfig.maxSingleBuyableTicketQuantity;
  const maxCartItemQuantity = +raffleConfig.maxCartItemQuantity;
  const { landingModalShowingCount, showShareButton, banners } = raffleConfig;

  return {
    runningOutPercentage,
    maxCartItemQuantity,
    maxSingleBuyableTicketQuantity,
    banners,
    showShareButton,
    landingModalShowingCount,
  };
}

export default getConfigs;
